<script lang="ts">
  import WorkOrderSummaryTag from "../../../../../../../_shared/_modules/work-order-summary-tag"
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { mdiArchiveOutline } from "@mdi/js"
  import type { WorkOrderRow } from "../../../../_logic/work-order-table-model"
  import { archivePresentation } from "../../../../../../../_shared/_logic/archive-presentation"

  type Props = {
    row: WorkOrderRow
  }

  const { row }: Props = $props()

  const archiveTooltip = $derived.by(() => {
    if (!row.workOrder.archived_at) return ""

    return archivePresentation(row.workOrder.archived_at, row.workOrder.archive_reason)
  })
</script>

<div class="summary-cell">
  <WorkOrderSummaryTag tag={row.workOrderSummaryTag} />
  {#if row.dueWarning}
    <StatusTag
      size="sm"
      status={row.dueWarning}
      tooltipContent={row.dueWarning.description ?? ""}
      disableTitle={true}
    />
  {/if}
  {#if row.workOrder.archived_at}
    <StatusTag
      variant="neutral"
      size="sm"
      label="Archiviert"
      icon={mdiArchiveOutline}
      color="#7b8794"
      tooltipContent={archiveTooltip}
    />
  {/if}
</div>

<style lang="less">
  .summary-cell {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.35rem;
    min-width: 0;
  }
</style>
